// @ts-ignore
import Vue from 'vue';
// @ts-ignore
import { Component, Prop } from "vue-property-decorator";

//Components
import WithRender from "Components/Search/PagesSearchCard/PageContentTypes/Literature/literature.html";


@WithRender
@Component()

export default class literature extends Vue {
	@Prop({}) title: string;
	@Prop({}) url: string;
	@Prop({}) highlightResults: any;
	@Prop({}) imageUrl: string;
}
